import { IAuthState } from './auth'
import { User } from './user'
import { CombinedState } from 'redux'
import { EventsState, TasksState } from './schedule'
import { PatientDashboardState, SearchPatientsState } from './patients'
import { History } from 'history'
import { HistoryLocationState } from './history'
import { SystemConfig } from './systemConfig'
import { ILocaleStore } from './locale'
import { ViewportState } from './viewport'
import { SearchCoachesState } from './coaches'
import { BulkActionState } from './bulk'
import { CoachesState } from '../store/reducers/clinicManagement/coaches/reducers'
import { UsersState } from '../store/reducers/clinicManagement/users/reducers'
import { NewUserState } from '../store/reducers/clinicManagement/newUser/reducers'
import { AlertsState } from './alert'
import { RealtimeAlertsState } from './realtimeAlerts'
import { OrgSettingsState } from '../store/reducers/orgSettings/types'
import { ChatState } from './chat'
import { MyPatientsState } from '../store/reducers/myPatients/types'
import { RecentlyViewedState } from '../store/reducers/recentlyViewed/types'

export interface ClinicManagementState {
	coaches: CoachesState
	users: UsersState
	newUser: NewUserState
}

export interface AppState {
	user: User
	schedule: CombinedState<{ tasks: TasksState; events: EventsState }>
	patientOverview: CombinedState<PatientDashboardState>
	searchCoaches: SearchCoachesState
	searchPatients: SearchPatientsState
	bulk: BulkActionState
	alerts: AlertsState
	clinicManagement: CombinedState<ClinicManagementState>
	realtimeAlerts: RealtimeAlertsState
	orgSettings: OrgSettingsState
	chat: ChatState
	myPatients: MyPatientsState
	recentlyViewed: RecentlyViewedState
}

export interface RootReducerState {
	auth: IAuthState
	router: History<HistoryLocationState>
	appReducer: AppState | Partial<AppState>
	systemConfig: SystemConfig
	locale: ILocaleStore
	viewport: ViewportState
}

export enum ROOT_REDUCER_ACTION_TYPES {
	ROOT_REDUCER_RESET = 'ROOT_REDUCER_RESET',
}

export interface RootReducerResetAction {
	type: ROOT_REDUCER_ACTION_TYPES.ROOT_REDUCER_RESET
}
